<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <h1 class="page-title">Corporate Leads Sheetview</h1>
            </div>
            <div class="col-sm-6 pull-right">
                <div class="col-sm-6 pull-right">
                    
                    <!-- Import Corporate FB leads -->
                    <span *ngIf="myrole=='1' || myrole=='14'">
                        <div class="col-sm-12 text-right">
                            <p><a href="{{s3url}}crm/sample-corporate-fb-import.csv" target="_blank">Sample CSV for fb</a></p>
                            <p><a class="btn btn-success text-white" (click)="showModalFb()"><i class="fa fa-file-excel"></i> Import Corporate Fb Leads</a></p>
                           </div>
                    </span>
                    <br>
                </div>
            </div>
        </div>
    </div>
    
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-sm-3 mt-2">
                        <input class="form-control" [(ngModel)]="search" type="text" (keyup)="getCorporateLeads(0,perpage)" placeholder="Search" />
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Select Status" (selectionChange)="getCorporateLeads(0,perpage)" [(ngModel)]="status">
                            <mat-option [value]="">Select Status</mat-option>
                            <mat-option [value]="status.id" *ngFor="let status of corporate_lead_status_list">{{status.status_name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Circle" (selectionChange)="getCorporateLeads(0,perpage)" [(ngModel)]="circle" multiple>
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Bds" (selectionChange)="getCorporateLeads(0,perpage)" [(ngModel)]="bd" multiple >
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds_list">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>
                    
                </div>
                <div class="col-sm-4 mt-2">
                    <mat-form-field appearance="fill">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate #dateRangeStart placeholder="Start date">
                            <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                    <mat-icon (click)="clearDate()">clear</mat-icon>

                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="getCorporateLeads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>

                    <a routerLink="/add-corporate-lead" class="ml-2 btn btn-success">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Corporate Lead
                    </a>
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>

            <div class="text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <hot-table [hiddenColumns]="hideColumn" [hotId]="id" [colHeaders]="true" [columnSorting]="false" width="100%" [height]="600" [rowHeaders]="true" licenseKey="non-commercial-and-evaluation" [data]="corporate_leads" [beforeChange]="onBeforeChange" [autoWrapRow]="false" [autoWrapCol]="false" [afterOnCellMouseDown]="afterOnCellMouseDownCallBack">
                <hot-column data="id" [readOnly]="true" title="ID"></hot-column>
                <hot-column data="glamyo_patient_id" [readOnly]="true" title="Glamyo Patient Id"></hot-column>
                <hot-column data="created_on" [readOnly]="true" title="Lead Time"></hot-column>
                <hot-column data="company_name" [readOnly]="false" title="Company Name"></hot-column>
                <hot-column data="client_name" [readOnly]="false" title="Client Name"></hot-column>
                <hot-column data="designation" [readOnly]="false" title="Designation"></hot-column>
                <hot-column data="company_email" [readOnly]="false" title="Company Email"></hot-column>
                <!--------Nimbus Click to Call----------->
                <hot-column renderer="html" data="nimbus_click_to_call" [readOnly]="true" title="Nimbus C2C"></hot-column>
                <!--------Nimbus Click to Call----------->
                <hot-column data="company_contact_number" [readOnly]="true" title="Company Contact Number"></hot-column>
                
                <hot-column data="number_of_employee" [readOnly]="false" title="Number of Employee"></hot-column>
                <hot-column data="circle_name" type="dropdown" [source]="sheetCircle" [readOnly]="false" title="Circle"></hot-column>
                <hot-column data="incorporate_licence_text" type="dropdown" [source]="incorporate_licence" [readOnly]="false" title="Incorporate license"></hot-column>
                <hot-column data="cover_type_text" type="dropdown" [source]="cover_type" [readOnly]="false" title="Cover type"></hot-column>
                <hot-column data="policy_type_text" type="dropdown" [source]="policy_type" [readOnly]="false" title="Policy Type"></hot-column>
                <hot-column data="sum_insured_text" type="dropdown" [source]="sum_insured" [readOnly]="false" title="Sum insured looking for ?"></hot-column>
                <hot-column data="renew_date_format" type="date" dateFormat='MM/DD/YYYY' [readOnly]="false" title="Renewal Date"></hot-column>
                <hot-column data="bd_email" type="dropdown" [source]="bds" [readOnly]="false" title="Select User"></hot-column>
                <hot-column data="status_name" type="dropdown" [source]="corporate_lead_status" [readOnly]="false" title="Status"></hot-column>
                <hot-column data="followup_date_format" type="date" dateFormat='MM/DD/YYYY' [readOnly]="false" title="Followup Date"></hot-column>
                <hot-column width="500" data="description" [readOnly]="false" title="Description"></hot-column>
            </hot-table>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div> 
       
    </div>

</div>
<!-- The Modal -->
<div class="modal fade" id="myModalfb">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Corporate Fb Data </h4>
          <button type="button" class="close" (click)="hideModalFb()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadFb (change)="selectFileFb($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalFb()">Close</button>
        </div>
      </div>
    </div>
  </div>

<!-----------------For Nimbus Click to Call-------------------------->
<div class="modal fade" id="nimbus_click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Nimbus Call Progression</h4>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
            <div class="form-group">
              <div class="row">
                <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                  <i class="fa fa-cog fa-spin"></i><br />
                  <h2>Nimbus Call is under progress.</h2>
                </div>
              </div>
            </div>
          </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" [disabled]="nimbus_end_to_call_btn_disable" class="btn btn-success" (click)="endNimbusClicktoCall()">Close</button>
        </div>
      </div>
    </div>
</div>